import { render, staticRenderFns } from "./ReportSelector.vue?vue&type=template&id=051f06e8&scoped=true&"
import script from "./ReportSelector.vue?vue&type=script&lang=js&"
export * from "./ReportSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReportSelector.vue?vue&type=style&index=0&id=051f06e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f06e8",
  null
  
)

export default component.exports